/**
 * A metric cell's percentage with, when there is one, its formatted monetary value on a second line
 * under it.
 */
export function MonetaryUnderPercent({
	primary,
	secondary,
	"data-qualifier": dataQualifier,
}: {
	primary: string;
	secondary: string | undefined;
	"data-qualifier": string;
}): React.JSX.Element {
	// TODO(MDOT-25401): story test case TC-05 (MDOT-25346) asks for a loading/empty state when the value is
	// missing; a missing value renders nothing until the PM settles it.
	if (secondary === undefined) {
		return <>{primary}</>;
	}

	return (
		<div className="flex flex-col items-end leading-tight">
			<span>{primary}</span>
			<span className="text-xs text-(--palette-N400)" data-qualifier={dataQualifier}>
				{secondary}
			</span>
		</div>
	);
}
